export const passwordPattern =
  '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{1,}$';
export const ssnPattern = /^(\d{3}-\d{2}-\d{4}|XXX-XX-\d{4}|\*{3}-\*{2}-\d{4})$/;
export const tinPattern = /^\d{2}-\d{7}$/;
export const yearPattern = /^\d{4}$/;
export const lastFourSSNPattern = /^\d{4}$/;
